import { Box, Button, Divider } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

function DenyConsent({
	handleCancel,
	handleDeny,
	isDarkTheme,
	customDetails,
	denyButtonText,
	cancelButtonText,
	isConsentRenewal,
}) {
	const { t } = useTranslation();
	return (
		<Box>
			{isConsentRenewal && (
				<Divider
					sx={{
						marginTop: '2.5rem',
						marginBottom: '1.5rem',
						marginLeft: '-1.5rem',
						marginRight: '-1.5rem',
						width: 'calc(100% + 3rem)',
					}}
				/>
			)}
			<Box
				sx={{
					display: { xs: 'flex' },
					flexDirection: isConsentRenewal
						? { xs: 'column-reverse', md: 'row' }
						: 'row',
					gap: '0.75rem',
					justifyContent: isConsentRenewal ? 'flex-end' : 'center',
				}}
			>
				<Button
					variant={isConsentRenewal ? 'outlined' : 'text'}
					color={isConsentRenewal ? undefined : 'error'}
					onClick={handleDeny}
					sx={{
						minWidth: 'auto',
						width: isConsentRenewal ? { xs: '100%', md: 'auto' } : '80%',
						padding: '0.5rem 1.5rem',
						height: isConsentRenewal ? '2.75rem' : '2rem',
						textTransform: 'none',
						fontWeight: isConsentRenewal ? 400 : 600,
						fontSize: '0.875rem',
						borderRadius: isConsentRenewal ? '8px' : undefined,
						backgroundColor: isDarkTheme
							? 'transparent'
							: isConsentRenewal
							? customDetails?.secondaryColor || '#ffffff'
							: '#ffffff !important',
						color: isConsentRenewal
							? customDetails?.primaryColor || (isDarkTheme ? '#fff' : '#000')
							: '#E94B4B !important',
						borderColor: isConsentRenewal
							? customDetails?.primaryColor ||
							  (isDarkTheme ? '#7A8185' : '#D8E1EE')
							: '#E94B4B !important',
						marginRight: isConsentRenewal ? '0' : '1rem',
						boxShadow: isConsentRenewal ? 'none' : undefined,
						'&:hover': {
							backgroundColor: isDarkTheme
								? 'rgba(255, 255, 255, 0.08)'
								: isConsentRenewal
								? 'rgba(0, 0, 0, 0.04)'
								: 'rgba(233, 75, 75, 0.04) !important',
							borderColor: isConsentRenewal
								? customDetails?.primaryColor ||
								  (isDarkTheme ? '#7A8185' : '#D8E1EE')
								: '#E94B4B !important',
							boxShadow: isConsentRenewal ? 'none' : undefined,
						},
					}}
				>
					{denyButtonText || t('common.buttons.deny')}
				</Button>
				<Button
					variant="contained"
					onClick={handleCancel}
					sx={{
						minWidth: 'auto',
						width: isConsentRenewal ? { xs: '100%', md: 'auto' } : '80%',
						padding: '0.5rem 1.5rem',
						height: isConsentRenewal ? '2.75rem' : '2rem',
						textTransform: 'none',
						fontWeight: isConsentRenewal ? 400 : 600,
						fontSize: '0.875rem',
						borderRadius: isConsentRenewal ? '8px' : undefined,
						backgroundColor: customDetails?.primaryColor || undefined,
						boxShadow: isConsentRenewal ? 'none' : undefined,
						'&:hover': {
							backgroundColor: customDetails?.primaryColor
								? `color-mix(in srgb, ${customDetails.primaryColor} 85%, black 15%)`
								: undefined,
							boxShadow: isConsentRenewal ? 'none' : undefined,
						},
					}}
				>
					{cancelButtonText || t('common.buttons.cancel')}
				</Button>
			</Box>
		</Box>
	);
}

export default DenyConsent;
